import { CertificateApplicantValues } from "src/pages/pan/view/Dialog/PanFormDialogBox/panFormToCertificate";

/**
 * The applicant block of the Employer Certificate (name / father's name /
 * residential address / place).
 *
 * The PAN form the operator filled comes first — the reviewed source of truth,
 * and the only place that holds the APPLICANT's address rather than the
 * retailer's. `acknowledgement_*` and the raw application fields stay as
 * fallbacks for applications with no PAN form.
 *
 * Place follows the same chain the Affidavit uses: the PAN form, then the
 * `acknowledgement_place` typed at login, and only then the retailer's /
 * distributor's district.
 *
 * Office Address is the PAN form's office block too (DSA: the agent's counter,
 * PCO: the head office), and the photo is the one the PAN form printed.
 *
 * Used by the Download dialog (pre-fill, still editable there) and by the PAN
 * form's automatic generation, so both print the same values.
 */
export const employerCertificateApplicant = (
  data: any,
  fromForm: CertificateApplicantValues
) => ({
  applicantName:
    fromForm.applicantName || data?.acknowledgement_name || data?.name || "",
  fatherName:
    fromForm.fatherName ||
    data?.acknowledgement_father_name ||
    data?.parentName ||
    "",
  address: fromForm.address || data?.acknowledgement_address || "",
  place:
    fromForm.place ||
    data?.acknowledgement_place ||
    data?.retailerData?.district ||
    data?.distributorData?.district ||
    "",
  // Empty = the template falls back to the agent's profile address.
  officeAddress: fromForm.officeAddress || "",
  // The cropped copy the PAN form printed, else the applicant's own upload.
  photoUrl: data?.editedPhotoUrl || data?.passportPhotoUrl || "",
});

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/** Today as the certificate prints it: "5 October 2026". */
export const employerCertificateDate = () => {
  const today = new Date();
  return `${today.getDate()} ${MONTH_NAMES[today.getMonth()]} ${today.getFullYear()}`;
};
